<template>
  <div>
    <TableFilters
      :filters="['shop']"
      :columns="columns"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="SalesProducts"
              item-key="id"
              class="row-pointer product-list"
              id="indextable15"
            >
              <template v-slot:item.code="{ item }">
                <div>
                  {{ item.product.code }}
                </div>
              </template>
              <template v-slot:item.name="{ item }">
                <div>
                  {{ item.product.name }}
                </div>
              </template>
              <template v-slot:item.category="{ item }">
                <div>
                  {{ item.product.category.name }}
                </div>
              </template>
              <template v-slot:item.brand="{ item }">
                <div>
                  {{ item.product.brand.name }}
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import axios from '@/plugins/axios';
import { mapState } from 'vuex';

export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.5%',
        render: (item) => item?.no,
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.5%',
        render: (item) => item?.product.name,
      },
      {
        text: 'Code',
        value: 'code',
        show: true,
        align: 'left',
        disabled: false,
        width: '14.5%',
        render: (item) => item?.product.code,
      },

      {
        text: 'Category',
        value: 'category',
        show: true,
        align: 'right',
        disabled: false,
        width: '14.5%',
        render: (item) => item?.product.category.name,
      },
      {
        text: 'Brand',
        value: 'brand',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.5%',
        render: (item) => item?.product.brand.name,
      },
      {
        text: 'Quantity',
        value: 'total',
        show: true,
        disabled: false,
        align: 'center',
        width: '14.5%',
        render: (item) => item?.total,
      },
    ],
    SalesProducts: [],
    hide: '',
    // Filters
    filter: {
      shop: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },
  props: {
    ASC: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      axios
        .get(
          `reports/products/revenue?order=${this.ASC ? 'asc' : 'desc'}&shop=${
            filter.shop ? filter.shop : ''
          }`,
        )

        .then((res) => {
          let i = 1;
          this.SalesProducts = res.data.data;
          this.SalesProducts.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            callBack();
            // Update Pdf To List

            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.SalesProducts);
            // Update Pdf To List_Title
            if (this.ASC) {
              this.$store.commit('UPDATE_PDF_TITLE', 'Low Sales Products');
            } else {
              this.$store.commit('UPDATE_PDF_TITLE', 'Top Sales Products');
            }

            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDF_VISIBLE', false);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.SalesProducts.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 400);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.SalesProducts);
        for (let x = 0; x < Data.length; x++) {
          Data[x].name = Data[x].product.name;
          Data[x].code = Data[x].product.code;
          Data[x].category = Data[x].product.category.name;
          Data[x].brand = Data[x].product.brand.name;
        }

        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');

        doc.text(
          this.ASC ? 'Low Sales Products Report' : 'Top Sales Products Report',
          14,
          6,
        );

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        // let height;
        // if (
        //   this.filterDatas.shopquery == "" ||
        //   this.filterDatas.shopquery == null
        // ) {
        //   height = 10;
        // } else {
        //   this.filterDatas.shopquery
        //     ? doc.text(`Shop  -    ${this.filterDatas.shopquery}`, 14, 12)
        //     : null;
        //   height = 15;
        // }

        const conditions = [{ key: 'shopquery', label: 'Shop' }];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Add Date Range if both start and end are available
        if (this.filterDatas.start && this.filterDatas.end) {
          const dateRangeText = `Date Range - ${this.filterDatas.start} - ${this.filterDatas.end}`;
          doc.text(dateRangeText, 15, height);
          height += 5; // Increment offset
        }

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-salesproductss.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable15');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-salesproductss.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    ...mapState(['filterDatas']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
